import React from 'react';
import { Link } from 'react-router-dom';

import { useAvailabilityMetadata } from '../adapters/useAvailabilityMetadata';
import { formatMetadataDate, formatSharesYearQuarter } from '../utils/formatMetadataDate';

function MetadataInfoLine() {
	const { metadata, isLoading, isError } = useAvailabilityMetadata();

	if (isLoading) {
		return <p className='leading-6 text-gray-600'>Načítání informací o datech zdrojů…</p>;
	}

	if (isError || !metadata) {
		return null;
	}

	return (
		<p className='leading-6 text-gray-700'>
			Data platí pro kvartál <strong>{formatSharesYearQuarter(metadata.sharesYearQuarter)}</strong>. DIS-13
			aktualizováno ke dni <strong>{formatMetadataDate(metadata.dis13UpdatedAt)}</strong>, SCAU ke dni{' '}
			<strong>{formatMetadataDate(metadata.scauUpdatedAt)}</strong>.
		</p>
	);
}

export function IntroSection() {
	return (
		<div className='px-10 py-4 pb-12 max-w-[1260px] mx-auto space-y-4 text-gray-900 font-display'>
			<div className='max-w-3xl space-y-8'>
				<section className='space-y-4 text-gray-900'>
					<p className='leading-6'>
						<strong>Monitor Dostupnosti LP</strong> slouží k automatickému sledování dostupnosti léčivých přípravků ve
						smyslu § 39c odst. 2 písm. a) zákona č. 48/1997 Sb., o veřejném zdravotním pojištění.
					</p>
					<p className='leading-6'>
						Zadáním <strong>ATC</strong> kódu, názvu <strong>účinné látky</strong>, nebo{' '}
						<strong>názvu léčivého přípravku</strong> získáte informaci, zda byl léčivý přípravek v předchozím kvartálu
						dostupný v distribuci (<strong>&gt;5 % v DIS-13</strong>) a zda je uzavřena dohoda o nejvyšší ceně výrobce (
						<strong>DNC</strong>), nebo dohoda o úhradě (<strong>DoÚ</strong>) v aktuálním Seznamu cen a úhrad LP (
						<strong>SCAU</strong>).
					</p>
					<MetadataInfoLine />
					<p className='leading-6'>
						<Link
							to='/availability/metodika'
							className='text-cBlue-500 hover:text-blue-700 underline underline-offset-2 decoration-2'
						>
							Více se dozvíte v úplné metodice
						</Link>
					</p>
				</section>
			</div>
		</div>
	);
}
